/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Info_Line_2Inputs */

const es_components_buy_messages_modal_info_line_2 = /** @type {(inputs: Components_Buy_Messages_Modal_Info_Line_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para picos de uso, campañas o necesidades puntuales sin cambiar tu plan actual.`)
};

const en_components_buy_messages_modal_info_line_2 = /** @type {(inputs: Components_Buy_Messages_Modal_Info_Line_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal for usage spikes, campaigns, or one-time needs without changing your current plan.`)
};

/**
* | output |
* | --- |
* | "Ideal for usage spikes, campaigns, or one-time needs without changing your current plan." |
*
* @param {Components_Buy_Messages_Modal_Info_Line_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_info_line_2 = /** @type {((inputs?: Components_Buy_Messages_Modal_Info_Line_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Info_Line_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_info_line_2(inputs)
	return en_components_buy_messages_modal_info_line_2(inputs)
});
export { components_buy_messages_modal_info_line_2 as "components.buy_messages_modal.info.line_2" }